module.exports = __webpack_public_path__ + "assets/img/tentacle-idle.07d1dfea.png";